import { lazyLoadMedia } from './utils/lazyload';
import { initSwiper } from './library/swiper';
import { initFancybox } from './library/fancybox';
import { initNotyf } from './library/notification';
import { initializeTabs } from './library/tabs';
import { initTooltip } from './library/typpy';
import { initMarquee } from './library/marquee';
import { modal } from './library/modal';
import { initAccordion } from './library/accordion';
import {initRussianPhoneMask} from "./main/initTel";
import {slimselect} from "./library/slimselect";
import {initScrollToTop} from "./main/initScrollToTop";
import {initHeaderDropdownMenu} from "./main/initHeaderDropdownMenu";
import {initMobileMenu} from "./main/initMobileMenu";
import {initCatalogMore} from "./main/initCatalogMore";

/*import 'dragscroll';*/
document.addEventListener('DOMContentLoaded', () => {
    lazyLoadMedia();
    initAccordion();
    slimselect();
    initSwiper();
    initScrollToTop();
    initRussianPhoneMask();
    // initFancybox();
    // initNotyf();
    initializeTabs();
    initMobileMenu();
    initHeaderDropdownMenu();

    const tabs = document.querySelectorAll('.catalog__cruise-tab');
    if (tabs.length > 0) {
        tabs.forEach(tab => {
            initCatalogMore(tab as HTMLElement);
        });
    } else {
        initCatalogMore();
    }
    // initTooltip();
    // initMarquee();
    modal;
});

